import React, {Suspense, lazy} from 'react';
import {
  ROUTE_ADD_GRN,
  ROUTE_ADD_PO,
  ROUTE_ADD_PR_HEADER,
  ROUTE_ADD_PURCHASE_ORDER,
  ROUTE_APPROVE_REJECT_PR,
  ROUTE_EDIT_PO,
  ROUTE_EDIT_PR,
  ROUTE_MANAGE_GOODS_RECEIPT,
  ROUTE_MANAGE_PURCHASE_ORDER,
  ROUTE_PR_HEADER,
  ROUTE_RESUBMIT_PO_LINE_ITEM,
  ROUTE_VIEW_PO_LINE_ITEM,
  ROUTE_VIEW_PR,
} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import {Spin} from 'antd';

const PurchaseRequisition = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.PurchaseRequisition})));

const AddPRHeader = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.AddPRHeader})));

const ViewPR = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ViewPurchaseRequisition})));

const EditPR = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.UpdatePurchaseRequisition})));

const AddPO = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.AddPO})));

const ManagePO = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ManagePurchaseOrder})));

const ManageGRN = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ManageGoodsReceiptNote})));

const AddGRN = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.AddGRN})));

const EditPO = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.EditPO})));

const ViewPOLineItem = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ViewPurchaseOrderLineItem})));

const ResubmitPO = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ResubmitPurchaseOrderLineItem})));

const AddPurchaseOrder = lazy(() =>
  import('../../../screens/PurchaseRequisition')
    .then(module => ({default:module.ViewPRHeaderAndLineItem})));

const PurchaseRequisitionNavigation = [
  {
    path: ROUTE_PR_HEADER,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <PurchaseRequisition />
      </Suspense>
    ),
  },

  {
    path: ROUTE_ADD_PR_HEADER,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddPRHeader />
      </Suspense>
    ),

  },

  {
    path: ROUTE_VIEW_PR,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewPR />
      </Suspense>
    ),
  },

  {
    path: ROUTE_APPROVE_REJECT_PR,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewPR />
      </Suspense>
    ),
  },

  {
    path: ROUTE_EDIT_PR,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditPR />
      </Suspense>
    ),
  },

  {
    path: ROUTE_ADD_PO,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddPO />
      </Suspense>
    ),
  },

  {
    path: ROUTE_MANAGE_PURCHASE_ORDER,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ManagePO />
      </Suspense>
    ),
  },

  {
    path: ROUTE_MANAGE_GOODS_RECEIPT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ManageGRN />
      </Suspense>
    ),
  },

  {
    path: ROUTE_ADD_GRN,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddGRN />
      </Suspense>
    ),
  },

  {
    path: ROUTE_EDIT_PO,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditPO />
      </Suspense>
    ),
  },

  {
    path: ROUTE_VIEW_PO_LINE_ITEM,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewPOLineItem />
      </Suspense>
    ),
  },

  {
    path: ROUTE_RESUBMIT_PO_LINE_ITEM,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ResubmitPO />
      </Suspense>
    ),
  },

  {
    path: ROUTE_ADD_PURCHASE_ORDER,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddPurchaseOrder />
      </Suspense>
    ),
  },
];

export default PurchaseRequisitionNavigation;
